import { useNavigate } from "react-router";
import success from "../../assets/images/animation_300_lb53ccn4 (1).gif";
import "./SucessModel.scss";

export default function SucessModal({ page, name, post, onClick }) {
  const navigate = useNavigate();
  onClick = () => {
    if (page !== window.location.pathname) {
      navigate(page);
    } else {
      window.location.reload();
    }
  };
  return (
    <div onClick={onClick}>
      <div className="modal-backdrop fade show success-model"></div>
      <div
        style={{ display: "block" }}
        className="modal fade show modal-sm"
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog ">
          <div className=" modal-content ">
            <div>
              <img className="w-100 " src={success} alt="" />
            </div>
            <p className="text-center pb-3">
              A {name} has been {post} successfully
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
